<template>
  <div class="pack-v4">
    <div class="pack-v4__header">
      <div class="pack-v4__meal">
        <slot name="meal" />
      </div>
      <div class="pack-v4__ccal">
        <slot name="ccal" />
      </div>
    </div>
    <div class="pack-v4__content">
      <div class="pack-v4__img">
        <slot name="img" />
      </div>
      <div
        v-if="!!$slots.name"
        class="pack-v4__name"
      >
        <slot name="name" />
      </div>
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  mounted () {
    this.firebasePerformanceCustomTraceStop('menuChanging')
  },
  methods: {
    ...mapActions({
      firebasePerformanceCustomTraceStop: 'analytics/firebasePerformanceCustomTraceStop',
    }),
  },
}
</script>

<style lang="scss">
.pack-v4 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: map-get($colors, 'black');
  background: map-get($colors, 'white');
  padding: .20rem;
  height: 100%;
  border-radius: .16rem;
  font-size: .16rem;
  &__header {
    margin-bottom: .18rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    @include typography('b3', 'medium');
  }
  &__meal {
    @include typography('b3', 'bold');
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: map-get($colors, 'secondary');
    display: flex;
    align-items: center;
  }
  &__ccal {
    @include typography('b3', 'medium');
  }
  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  &__name {
    @include typography('b2', 'medium');
    text-align: center;
    line-clamp: 2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  &__img {
    width: 1.6rem;
    height: 1.16rem;
    &:not(:last-child) {
      margin-bottom: .16rem;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &__btn {
    &--custom {
      width: .24rem;
      height: .24rem;
      padding: .04rem;
      border-radius: 0.08rem;
      background-color: map-get($colors, 'white');
      border: 1px solid map-get($colors, 'grey_8');
      display: inline-flex;
      justify-content: center;
      align-items: center;
      &:not(:last-child) {
        margin-right: 0.08rem;
      }
      &:hover {
        background-color: map-get($colors, 'grey_8');
      }
    }
  }
  &--selector {
    .pack-v4 {
      &__img {
        width: 2.08rem;
        height: 1.46rem;
      }
    }
  }
  &--card {
    .pack-v4 {
      &__header {
        margin-bottom: .28rem;
      }
      &__meal {
        display: flex;
        justify-content: center;
      }
      &__ccal {
        font-size: .16rem;
        line-height: .24rem;
      }
      &__name {
        padding: .12rem .16rem;
        font-size: .16rem;
        line-height: .24rem;
      }
      &__img {
        width: 2.48rem;
        height: 1.72rem;
      }
    }
  }
}
</style>
